module.exports = [
  // type
  require('./Complex'),

  // construction function
  require('./function/complex')
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/type/complex/index.js
// module id = 2I7C
// module chunks = 0